import React, { useEffect, useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { UNAUTHORIZED_EVENT } from "../../services/api/apiClient";
import { isAuthenticated } from "../../services/api/adminService";

export const ADMIN_LOGIN_PATH = "/admin/login";
export const ADMIN_HOME_PATH = "/admin";

/**
 * Renders its children only while an owner token is stored.
 *
 * - No token: redirect to /admin/login, remembering where the owner was going.
 * - Any protected request answering 401 (apiClient clears the token and fires
 *   'hh:unauthorized'): redirect to /admin/login with reason 'expired'.
 *
 * This is a convenience gate only; the backend enforces access on every call.
 */
export default function AdminGuard({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [authed, setAuthed] = useState(isAuthenticated);

  useEffect(() => {
    const onUnauthorized = () => {
      setAuthed(false);
      navigate(ADMIN_LOGIN_PATH, {
        replace: true,
        state: { from: location.pathname, reason: "expired" },
      });
    };
    window.addEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
    return () => window.removeEventListener(UNAUTHORIZED_EVENT, onUnauthorized);
  }, [navigate, location.pathname]);

  if (!authed || !isAuthenticated()) {
    return <Navigate to={ADMIN_LOGIN_PATH} replace state={{ from: location.pathname }} />;
  }
  return children;
}
